module.exports = __webpack_public_path__ + "static/media/fowlit-blue-bird.cc33056f.svg";